<template>
	<CalendarCard
		body-class="min-h-0 grow h-75 lg:h-142"
		:initial-view="desiredView"
		:show-navigation="desiredView !== 'listWeek'"
		:show-view-switcher="desiredView !== 'listWeek'"
	/>
</template>

<script setup lang="ts">
import type { CalendarViewType } from "@/components/calendar/CalendarToolbar.vue"
import { useWindowSize } from "@vueuse/core"
import { computed } from "vue"
import CalendarCard from "@/components/calendar/CalendarCard.vue"

const { width } = useWindowSize()

/** Below the `lg` breakpoint the month grid is too dense, so we fall back to the agenda list. */
const desiredView = computed<CalendarViewType>(() => (width.value >= 1024 ? "dayGridMonth" : "listWeek"))
</script>
